/**
 * @desc centerId查询映射关系
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.CenterCountyMappingResponseDto>;
export function request(centerId: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/centerCounty/selectByCenterId/${centerId}`, {
      method: "GET",

      ...options,
    }),
  );
}
